import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { withAnalytics } from '@redbubble/boom-analytics';
import withToggleMatureContent from '../../containers/apollo/withToggleMatureContent';
import Footer from './Footer';

const ExploreFooter = compose(
  withAnalytics,
  injectIntl,
  withToggleMatureContent
)(Footer);

ExploreFooter.displayName = Footer.displayName;

export default ExploreFooter;
